export default __webpack_public_path__ + "static/sketch-to-figma-e53645dbc3050f7c5d7563c6a5832a64.jpg";